(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lc-bolt-finishes"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lc-bolt-finishes')) {
  customElements.define('lc-bolt-finishes', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.addEventListener('click', async event => {
        const button = event.target.closest('[data-bolt-finish]');
        if (!button || !this.contains(button)) return;
        const request = this.request = (this.request || 0) + 1;
        const image = this.querySelector('.lc-bolt-finishes__image');
        const nextImage = new Image();
        nextImage.sizes = image.sizes;
        nextImage.srcset = button.dataset.finishSrcset;
        nextImage.src = button.dataset.finishSrc;
        this.setAttribute('aria-busy', 'true');
        try {
          await nextImage.decode();
          if (request !== this.request || !this.isConnected) return;
          image.srcset = button.dataset.finishSrcset;
          image.src = button.dataset.finishSrc;
          image.alt = button.dataset.finishAlt;
          this.querySelector('[data-bolt-finish-label]').textContent = button.dataset.finishLabel;
          this.querySelectorAll('[data-bolt-finish]').forEach(swatch => {
            swatch.setAttribute('aria-pressed', String(swatch === button));
          });
        } catch (error) {
          // Keep the current photograph and selection if the new image cannot load.
        } finally {
          if (request === this.request) this.removeAttribute('aria-busy');
        }
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lc-sketch-banner-design"] && !Shopify.designMode) return;
  try {
    function lcSketchBannerInit(root = document) {
  root.querySelectorAll('.lc-sketch-banner .hero').forEach(hero => {
    if (hero.dataset.ready) return;
    hero.dataset.ready = 'true';
    hero.querySelectorAll('[data-lc-finish]').forEach(button => {
      button.addEventListener('click', () => {
        const engine = hero.querySelector('.engine');
        const bolt = hero.querySelector('.hero-detail img');
        engine.removeAttribute('srcset');
        engine.src = button.dataset.engine;
        engine.alt = 'KTM engine drawing with ' + button.dataset.lcFinish + ' titanium bolts';
        bolt.removeAttribute('srcset');
        bolt.src = button.dataset.bolt;
        bolt.alt = button.dataset.lcFinish + ' M6x15 titanium bolt photograph';
        hero.querySelector('.finish-label').textContent = button.dataset.lcFinish;
        hero.querySelectorAll('[data-lc-finish]').forEach(option => {
          option.setAttribute('aria-pressed', String(option === button));
          option.classList.toggle('selected', option === button);
        });
      });
    });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => lcSketchBannerInit());
} else {
  lcSketchBannerInit();
}
document.addEventListener('shopify:section:load', event => lcSketchBannerInit(event.target));
document.addEventListener('shopify:block:select', event => {
  const button = event.target.closest('.lc-sketch-banner [data-lc-finish]');
  if (button) button.click();
});
  } catch(e) { console.error(e); }
})();

})();
